<template>
    <b-modal
        :id="'assignment-show-edit-feedback-modal' + this.feedbackIn.id"
        :title="$t('assignment.feedback_overview')"
        modal-class="apprentice-default-modal"
        ok-only
        @ok="onOk"
        :ok-title="$t('common.close')"
        size="lg">
        <b-form-textarea
            class="apprentice-textarea"
            id="teachers-assignment-feedback-input"
            v-model="text"
            :placeholder="text"
            rows="3"
            max-rows="6">
        </b-form-textarea>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-assignment-show-edit-feedback-modal-component',
    props: ['feedbackIn'],
    data() {
        return {
            text: this.feedbackIn.text,
        };
    },
    methods: {
        onOk() {
            this.alert.saving();

            let data = {
                text: this.text,
            };

            this.axios.post(this.routes.assignmentFeedbackUpdate(this.feedbackIn.id), data).then(
                (response) => {
                    this.feedbackIn.update(response.data.assignment);

                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped></style>
